<script setup lang="ts">
import { formatRelative } from 'date-fns';

import KParentTooltip from '@/components/tooltips/KParentTooltip.vue';
import * as commonConstants from '@/constants/common';

export interface Props {
  datetime?: string;
}
const props = withDefaults(defineProps<Props>(), {
  datetime: undefined,
});
</script>

<template>
  <time :datetime="props.datetime" :class="$style.kTime" data-testid="kTime">
    <template v-if="props.datetime">
      <KParentTooltip>{{ props.datetime }}</KParentTooltip>
      {{ formatRelative(new Date(props.datetime), new Date()) }}
    </template>
    <template v-else>
      {{ commonConstants.EM_DASH }}
    </template>
  </time>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.kTime {
}
</style>
